<script setup>

import { Facebook, Twitter, Linkedin, Youtube } from "lucide-vue-next";
import { useThemeStore } from "../../stores/themeStore";
import theme from "../../theme";
import index from '@/dashbaord/index.vue'
const themeStore = useThemeStore();
</script>
<template>
  <section class="py-16 px-4 md:px-8 lg:px-16 bg-white">
    <!-- Heading -->
    <div class="text-center mb-12">
      <h2 class="text-3xl md:text-4xl font-bold mb-4">Our Teachers</h2>
      <p class="text-gray-500 max-w-2xl mx-auto">
        If you are going to use a passage of you need to be sure there isn't
        anything embarrassing hidden in the middle of text
      </p>
    </div>
    <!-- Cards Grid -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8"
    >
      <div
        v-for="(teacher, index) in themeStore.theme.Teachers"
        :key="index"
        class="bg-white cursor-pointer rounded-lg shadow-md overflow-hidden transform transition-all duration-300 hover:scale-[1.02] hover:shadow-lg"
      >
        <!-- Dynamic Image -->
        <img
          :src="teacher.image"
          :alt="teacher.name"
          class="w-full h-60 object-cover"
        />

        <!-- Info -->
        <div class="text-center p-4">
          <h3 class="text-lg font-semibold mb-1">{{ teacher.name }}</h3>
          <p class="text-sm text-gray-500 mb-4">{{ teacher.title }}</p>
          <!-- Dynamic Social Icons -->
          <div class="flex justify-center gap-3">
            <a
              :href="teacher.socials.facebook"
              class="text-blue-800 hover:text-yellow-400 transition-colors"
              ><Facebook :size="18"
            /></a>
            <a
              :href="teacher.socials.twitter"
              class="text-blue-800 hover:text-yellow-400 transition-colors"
              ><Twitter :size="18"
            /></a>
            <a
              :href="teacher.socials.youtube"
              class="text-blue-800 hover:text-yellow-400 transition-colors"
              ><Youtube :size="18"
            /></a>
            <a
              :href="teacher.socials.linkedin"
              class="text-blue-800 hover:text-yellow-400 transition-colors"
              ><Linkedin :size="18"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
